import { useMutation } from "react-query";

import useApiHelper from "../../hooks/useApiHelper";
import { DefaultResponseWithData } from "../../models/system/DefaultResponse";
import { RegisterRequest, RegisterResponse } from "../../models/auth/RegisterRequest";

export function useRegister() {
  const { post } = useApiHelper();

  const register = useMutation({
    mutationFn: (body: RegisterRequest) =>
      post<RegisterRequest, DefaultResponseWithData<RegisterResponse>>(
        "/auth/register",
        body
      ),
  });

  return { register };
}
